export default "__VITE_ASSET__DrnVeHbk__"